import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Unregister any previously registered service workers.
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(async registrations => {
        for (const registration of registrations) {
            await registration.unregister();
        }
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map(name => caches.delete(name)));
    });
}

// One-time migration: clear Auth0 localStorage cache so all existing sessions are
const MIGRATION_KEY = 'ev_auth_rt_v2';
if (!localStorage.getItem(MIGRATION_KEY)) {
    Object.keys(localStorage)
        .filter(key => key.startsWith('@@auth0spajs@@'))
        .forEach(key => localStorage.removeItem(key));
    localStorage.setItem(MIGRATION_KEY, '1');
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));

